module.exports = __webpack_public_path__ + "static/media/balanced.e7f4d2dc.png";